module.exports = __webpack_public_path__ + "static/media/prop-2@2x-thumb.69c960be.webp";